import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

export default function TermsPage() {
  const sections = [
    {
      title: 'Acceptance of these terms',
      paragraphs: [
        'These Terms of Service govern your use of the Top 3 Football Tipsters website, associated pages, and any paid subscription products offered through it (collectively, the "Service"). By accessing the Service, creating an account, or purchasing a subscription, you confirm that you have read, understood, and agree to be bound by these Terms in full. If you do not agree with any part of these Terms, you must stop using the Service immediately.',
        'We may revise these Terms from time to time. Where a change is material we will notify active subscribers by email at least 14 days before it takes effect. Continued use of the Service after any revision becomes effective constitutes your acceptance of the updated Terms.'
      ]
    },
    {
      title: 'Eligibility',
      paragraphs: [
        'You must be at least 18 years old — or the legal age of majority in your country of residence, whichever is higher — to use the Service. By using the Service you represent and warrant that you meet this requirement and that betting on sporting events is lawful in the jurisdiction from which you access the Service.'
      ],
      bullets: [
        'You are solely responsible for verifying local laws before placing any wager based on our content.',
        'We do not accept subscribers from jurisdictions where sports-betting services are prohibited.',
        'Any account found to be operated by a minor will be closed immediately and any remaining balance forfeited.'
      ]
    },
    {
      title: 'Nature of the Service',
      paragraphs: [
        'Top 3 Football Tipsters provides football-betting information, analysis and predictions (the "Daily Double") produced by our team of football analysts. All content published on the Service is provided for informational and entertainment purposes only. Nothing on the Service constitutes financial, investment, legal, or professional advice.',
        'Sports betting involves substantial risk of loss. Past performance of any selection, market, or strategy is not a guarantee of future results. You alone are responsible for every wager you decide to place, for the amount you stake, and for any resulting profit or loss.'
      ]
    },
    {
      title: 'Subscriptions, pricing, and refunds',
      paragraphs: [
        'Certain features of the Service require a paid subscription. Pricing is displayed in Euros (EUR) on the Subscribe page and includes all applicable taxes unless stated otherwise. Prices may change at any time; any change will not affect subscriptions that have already been paid for.'
      ],
      bullets: [
        'All subscriptions begin on the date payment is confirmed and end at the close of the paid period. Auto-renewal is not enabled by default.',
        'Due to the digital nature of the content, subscriptions are generally non-refundable once access has been provided. Statutory rights available to you under applicable consumer law are unaffected.',
        'Subscriptions cover a fixed number of consecutive days (15 or 30) starting from activation.',
        'Payments made via cryptocurrency are settled at the on-chain confirmed amount; network fees are the responsibility of the sender.'
      ]
    },
    {
      title: 'Account security',
      paragraphs: [
        'You are responsible for maintaining the confidentiality of any credentials associated with the Service, and for all activity that occurs under your account. You must notify us immediately at premiumtipsters@tip1x2bet.com if you suspect any unauthorized use. We may suspend or terminate access without notice if we detect suspicious activity or a security breach.'
      ]
    },
    {
      title: 'Acceptable use',
      paragraphs: [
        'When using the Service you agree not to:'
      ],
      bullets: [
        'Share, resell, redistribute, or publish any Daily Double or archive content received through your subscription.',
        'Circumvent, disable, or interfere with any security or access-control feature of the Service.',
        'Use automated systems (bots, scrapers, harvesters) to access the Service without our prior written consent.',
        'Upload or transmit malicious code, spam, or unlawful content.',
        'Impersonate any person or misrepresent your affiliation with our analysts or with Top 3 Football Tipsters.'
      ]
    },
    {
      title: 'Intellectual property',
      paragraphs: [
        'All content published on the Service — including but not limited to written analyses, tips, archives, graphics, logos, and the Top 3 Football Tipsters name — is the property of Top 3 Football Tipsters or its licensors and is protected by copyright, trademark, and other intellectual-property laws. You are granted a personal, non-transferable, revocable licence to view this content solely in connection with your subscription. Any other use is strictly prohibited.'
      ]
    },
    {
      title: 'Third-party services and links',
      paragraphs: [
        'The Service may contain links to third-party websites (such as payment processors or brand information pages). We do not control these websites and are not responsible for their content, privacy practices, or availability. Your dealings with any third party are solely between you and that third party.'
      ]
    },
    {
      title: 'Limitation of liability',
      paragraphs: [
        'To the maximum extent permitted by law, Top 3 Football Tipsters, its analysts, employees, and contractors shall not be liable for any indirect, incidental, consequential, or special damages arising out of or in connection with your use of the Service, including but not limited to loss of profits, loss of data, or losses arising from bets placed on the basis of any tip. Our aggregate liability for any claim relating to the Service is limited to the amount you have paid for the subscription during the twelve (12) months immediately preceding the event giving rise to the claim.'
      ]
    },
    {
      title: 'Termination',
      paragraphs: [
        'We may suspend or terminate your access to the Service at any time, with or without notice, if we reasonably believe that you have breached these Terms, engaged in fraudulent activity, or if we discontinue the Service.'
      ]
    },
    {
      title: 'Contact',
      paragraphs: [
        'For any question about these Terms please contact us at premiumtipsters@tip1x2bet.com. We aim to respond to every enquiry within 12 hours.'
      ]
    }
  ];

  return (
    <LegalPageLayout
      title="Terms of Service"
      updated="June 2026"
      intro="These Terms govern your access to and use of Top 3 Football Tipsters. Please read them carefully before subscribing."
      sections={sections}
    />
  );
}
